const LOCAL_STORAGE_KEYS = {
  TOKEN: 'token',
  CREATE_SURVEY_FORM: 'create_survey_form',
  HISTORY_CREATE_SURVEY_FORM: 'history_create_survey_form',
  CURRENT_STEP_HISTORY_CREATE_SURVEY_FORM: 'current_step_history_create_survey_form',
  SEND_EMAIL_FORGOT_PASSWORD: 'send_email_forgot_password',
};

export default LOCAL_STORAGE_KEYS;
